import { useEffect, useRef, useState } from 'react'



import { useTranslation } from 'src/utils/i18n'

import Grid from '@mui/material/Grid'

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'

import Image from 'next/image'
import dayjs from 'dayjs'

import Link from 'next/link'
import { Icon } from '@iconify/react'

import { Button, Modal, Checkbox, Carousel } from 'antd'

import navigation from 'src/navigation/vertical'
import { messageInfo } from 'src/components/Message'

// components
import UserVerify from 'src/@core/components/user-verify'
import AdvancedShow from 'src/@core/components/advanced-show'
import IosVerfiyProcess from 'src/@core/components/ios-verfiy-process'
import RecentCard from 'src/@core/components/common/recentCard'
import FirstBinding from 'src/components/FirstBinding'
import ExpirationReminder from 'src/components/ExpirationReminder'

import {
  getCallHistory,
  getContact,
  getSmsChatSummary,
  getAlbumSummary,
  getInstalledApp,
  getLocation,
  getWifi,
  getWhatsappChatSummary,
  getSafariHistory,
  getLineChatSummary,
  getAllDashboard,
  extendSubscriptionTime
} from '/src/@api/dashboard'
import { userDeviceCurrent, sendLikeType, getUserAccountOrder } from 'src/@api/login'
import axios from 'axios'
import byteConversion from 'src/utils/byteConversion'
import { isBasicOrderLevel } from 'src/utils/orderLevel'
import { fetchRenewProductIdForOrder } from 'src/utils/renewalPlans'
import { resolveDeviceOrder, resolveCardSubscription } from 'src/utils/currentOrder'
import { matchCurrentDevice, reloadAfterRenewSuccess } from 'src/utils/refreshSubscriptionExpire'

import { useDispatch, useSelector } from 'react-redux'
import { advancedShow, setCurrentTab, toggleNavVisibility, changeExtremeService, fetchResetTime, selectDeviceRequestKey } from 'src/store/apps/Common'
import ExtremeUpgradeModal from 'src/@core/components/modal/extreme-upgrade'
import {
  isAdvancedVerificationIncomplete,
  isResetTimePending,
  shouldApplyIosExtremeBindGate
} from 'src/utils/iosIcloudBindStatus'
import { resolveDeviceSubscriptionStatus, SUBSCRIPTION_STATUS } from 'src/utils/subscriptionStatus'
import { parseExpireMs, resolveDeviceExpireTime } from 'src/utils/subscriptionExpire'
import { useRouter } from 'next/router'

let allIcon = [
  {
    id: 1,
    name: 'Photo',
    img: '/images/dashboard/new-ios/photos.png',
    num: 0,
    href: '/photos',
    basic: true
  },
  {
    id: 2,
    name: 'Video',
    img: '/images/dashboard/new-ios/video.svg',
    num: 0,
    href: '/video',
    basic: true
  },
  {
    id: 3,
    name: 'Locations',
    img: '/images/dashboard/new-ios/gps.png',
    num: 0,
    href: '/locations/gps',
    basic: true
  },
  {
    id: 4,
    name: 'Contact',
    img: '/images/dashboard/new-ios/contacts.png',
    num: 0,
    href: '/contacts',
    basic: true
  },
  {
    id: 5,
    name: 'Mail',
    img: '/images/dashboard/new-ios/email.svg',
    num: 0,
    href: '/mail',
    basic: true
  },
  {
    id: 6,
    name: 'iCloud drive',
    img: '/images/dashboard/new-ios/icloud-drive.svg',
    num: 0,
    href: '/i-cloud-drive',
    basic: true
  },
  {
    id: 7,
    name: 'Note',
    img: '/images/dashboard/new-ios/note.png',
    num: 0,
    href: '/notes',
    basic: true
  },
  {
    id: 8,
    name: 'Calendar',
    img: '/images/dashboard/new-ios/calendars.svg',
    num: 0,
    href: '/calendars',
    basic: true
  },
  {
    id: 9,
    name: 'Reminder',
    img: '/images/dashboard/new-ios/reminders.png',
    num: 0,
    href: '/reminders',
    basic: true
  },
  {
    id: 10,
    name: 'Text message',
    img: '/images/dashboard/new-ios/imessagers.svg',
    num: 0,
    href: '/text-messages',
    extreme: true
  },
  {
    id: 11,
    name: 'Call',
    img: '/images/dashboard/new-ios/calls.svg',
    num: 0,
    href: '/calls',
    extreme: true
  },
  {
    id: 12,
    name: 'Voicemail',
    img: '/images/dashboard/new-ios/voicemail.svg',
    num: 0,
    href: '/voicemail',
    extreme: true
  },
  {
    id: 13,
    name: 'WhatsApp',
    img: '/images/dashboard/new-ios/whatsapp.svg',
    num: 0,
    href: '/whatsapp',
    extreme: true
  },
  {
    id: 14,
    name: 'WA Business',
    img: '/images/dashboard/new-ios/whatappbusiness.svg',
    num: 0,
    href: '/wa-business',
    extreme: true
  },
  {
    id: 15,
    name: 'Line',
    img: '/images/dashboard/new-ios/line.svg',
    num: 0,
    href: '/line',
    extreme: true
  },
  {
    id: 16,
    name: 'Kik',
    img: '/images/dashboard/new-ios/kik.svg',
    num: 0,
    href: '/kik',
    extreme: true
  },
  {
    id: 17,
    name: 'WeChat',
    img: '/images/dashboard/new-ios/wechat.svg',
    num: 0,
    href: '/we-chat',
    extreme: true
  },
  {
    id: 18,
    name: 'Messenger',
    img: '/images/dashboard/new-ios/facebookmessage.svg',
    num: 0,
    href: '/messenger',
    extreme: true
  },
  {
    id: 19,
    name: 'Browser history',
    img: '/images/dashboard/new-ios/browsing.png',
    num: 0,
    href: '/browser-history',
    extreme: true
  },
  {
    id: 20,
    name: 'Browser Bookmark',
    img: '/images/dashboard/new-ios/bookmark.svg',
    num: 0,
    href: '/browser-bookmark',
    extreme: true
  },
  {
    id: 21,
    name: 'Install Apps',
    img: '/images/dashboard/new-ios/installapp.png',
    num: 0,
    href: '/apps',
    extreme: true
  },
  {
    id: 22,
    name: 'Wi-Fi network',
    img: '/images/dashboard/new-ios/wifi.svg',
    num: 0,
    href: '/wifi-networks',
    extreme: true
  },
  {
    id: 23,
    name: 'Skype',
    img: '/images/dashboard/new-ios/skype.svg',
    num: 0,
    href: '/skype',
    extreme: true
  },
  {
    id: 24,
    name: 'Teams',
    img: '/images/dashboard/new-ios/teams.svg',
    num: 0,
    href: '/teams',
    extreme: true
  },
  {
    id: 25,
    name: 'Telegram',
    img: '/images/dashboard/new-ios/telegram.svg',
    num: 0,
    href: '/telegram',
    extreme: true
  },
  {
    id: 26,
    name: 'Snapchat',
    img: '/images/dashboard/new-ios/snapchat.svg',
    num: 0,
    href: '/snapchat',
    extreme: true
  },
  {
    id: 27,
    name: 'Instagram',
    img: '/images/dashboard/new-ios/instagram.svg',
    num: 0,
    href: '/instagram',
    extreme: true
  },
  {
    id: 28,
    name: 'Facetime',
    img: '/images/dashboard/new-ios/facetime.svg',
    num: 0,
    href: '/facetime',
    extreme: true
  }
]

const _iconList = [
  {
    icon: '/images/dashboard/messages.svg',
    name: 'Messages',
    num: 0,
    href: ''
  },
  {
    icon: '/images/dashboard/whatsapp.svg',
    name: 'WhatsApp',
    num: 0,
    href: ''
  },
  {
    icon: '/images/dashboard/messenger2.svg',
    name: 'Messenger',
    num: 0,
    href: ''
  },
  {
    icon: '/images/dashboard/gps.svg',
    name: 'Locations',
    num: 0,
    href: ''
  },
  {
    icon: '/images/dashboard/photos.svg',
    name: 'Photo',
    num: 0,
    href: ''
  },
  {
    icon: '/images/dashboard/video.svg',
    name: 'Video',
    num: 0,
    href: ''
  },
  {
    icon: '/images/dashboard/calls.svg',
    name: 'Call',
    num: 0,
    href: ''
  },
  {
    icon: '/images/dashboard/browsing.svg',
    name: 'Browser',
    num: 0,
    href: ''
  },
  {
    icon: '/images/dashboard/snapchat.svg',
    name: 'Snapchat',
    num: 0,
    href: ''
  }
]

const Dashboard1 = () => {
  const store = useSelector(state => state.Common)

  // 设备切换后要重算卡片上的订单信息（到期时间 / Basic-Extreme 档位），
  // 否则在 /dashboard 内切换 iOS 设备时页面不会重新挂载，卡片会停留在上一台设备。
  const deviceRequestKey = useSelector(selectDeviceRequestKey)
  const dispatch = useDispatch()
  const router = useRouter()
  const { t, locale } = useTranslation('common')

  const [isInviteComment, setIsInviteComment] = useState(false)

  // 列表图标
  const [useList, setList] = useState(allIcon)

  // 克隆列表
  const [CloneList, setCloneList] = useState([])

  const [showOrderList, setShowOrderList] = useState(false)

  const orderListRef = useRef(null)
  const toggleButtonRef = useRef(null) // 绑定按钮引用
  const [orderIndex, setOrderIndex] = useState(0)

  // 点击按钮显示/隐藏弹窗
  const handleClickOutside = event => {
    // 检查点击的地方是否在按钮或弹窗内
    if (
      showOrderList &&
      orderListRef.current &&
      !orderListRef.current.contains(event.target) &&
      toggleButtonRef.current &&
      !toggleButtonRef.current.contains(event.target)
    ) {
      setShowOrderList(false)
    }
  }

  const changeOrder = (item, index) => {
    setOrderListData(item)
    setOrderIndex(index)
    setShowOrderList(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showOrderList]) // 依赖于 showOrderList

  const [iconList, setIconList] = useState([..._iconList])

  // InstalledApp
  const [useInstalledApp, setInstalledApp] = useState([])

  // messages
  const [useMessages, setMessages] = useState([])

  // location
  const [useLocations, setLocations] = useState([])

  // select
  const [selectLocations, setSelectLocations] = useState({})

  let Basic = window.localStorage.getItem('Basic')
  Basic = Basic == null || Basic == 0 ? true : false

  // 获取地理位置

  let location = async (latitude, longitude) => {
    try {
      let result = await axios({
        url: `${process.env.NEXT_PUBLIC_LONGITUDE_KEY}?latitude=${latitude}&longitude=${longitude}`,
        method: 'get'
      })
      let location = `${result.data.countryName} ${result.data.city} ${result.data.locality}`

      return `${location}`
    } catch (error) {
      return ''
    }
  }

  const [targetDeviceList, setTargetDeviceList] = useState([])

  // 获取设备信息

  const getTargetDeviceList = async () => {
    const deviceUsername =
      JSON.parse(localStorage.getItem('DeviceUser')) != null
        ? JSON.parse(localStorage.getItem('DeviceUser')).username
        : ''

    if (!deviceUsername) return

    let { data: result } = await getAllDashboard({
      username: deviceUsername,
      params: {
        category: 'USER_SUMMARY'
      }
    })

    const advance = result?.summary?.advance
    if (advance != null) {
      let data = advance.map(row => {
        if (row.device.snapshots != null) {
          return {
            device_name: row.device.device_name || '',
            product_type: row.device.product_type || '',
            serial_number: row.device.serial_number || '',
            unique_identifier: row.device.unique_identifier || '',
            product_version: row.device.snapshots[row.device.snapshots.length - 1].product_version,
            updated_at: dayjs(row.device.snapshots[row.device.snapshots.length - 1].updated_at).format(
              'YYYY-MM-DD HH:mm'
            ),
            size: byteConversion(row.device.snapshots[row.device.snapshots.length - 1].size)
          }
        } else {
          // return {
          //   device_name: row.device.device_name || '',
          //   product_type: row.device.product_type || '',
          //   serial_number: row.device.serial_number || '',
          //   product_version: '',
          //   updated_at: '',
          //   size: ''
          // }
        }
      })

      setTargetDeviceList(data.filter(row => row))
    }
  }

  useEffect(() => {
    let deviceUsername =
      JSON.parse(localStorage.getItem('DeviceUser')) != null
        ? JSON.parse(localStorage.getItem('DeviceUser')).username
        : ''

    if (!deviceUsername || Basic != false) return

    let timer

    try {
      const setCallData = async () => {
        if (!deviceUsername) return

        let check = await getCallHistory({
          username: deviceUsername,
          params: {
            category: 'CONTACT',
            offset: 0,
            limit: 1
          }
        })

        // 如果账号过期了,不在执行下面
        if (check.code === 1002) return

        let { data: allData, advanced } = await getAllDashboard({
          username: deviceUsername,
          params: {
            category: 'USER_SUMMARY'
          }
        })

        dispatch(changeExtremeService(advanced === true || advanced === 'true')) // 更新高级服务状态

        const summary = allData?.summary
        if (!summary || typeof summary !== 'object') return

        // 判断基础数据下载了没
        for (let key in summary) {
          if (key != 'advance' && summary[key] > 0) {
            localStorage.setItem('BasicTips', '1')
          }
        }

        // 获取所有列表数据
        let list = allIcon

        // let list2 = _iconList

        // 赋值基础数据
        list[0] && (list[0].num = summary?.photo ?? 0)
        list[1] && (list[1].num = summary?.video ?? 0)
        list[2] && (list[2].num = summary?.location ?? 0)
        list[3] && (list[3].num = summary?.contact ?? 0)
        list[4] && (list[4].num = summary?.mail ?? 0)
        list[5] && (list[5].num = summary?.drive ?? 0)
        list[6] && (list[6].num = summary?.note ?? 0)
        list[7] && (list[7].num = summary?.event ?? 0)
        list[8] && (list[8].num = summary?.reminder ?? 0)

        // 旧icon顺序基础数据赋值
        // list[19] && (list[19].num = allData?.summary?.calendar)
        // list[9] && (list[9].num = allData?.summary?.contact)
        // list[15] && (list[15].num = allData?.summary?.drive)
        // list[3] && (list[3].num = allData?.summary?.location)
        // list[16] && (list[16].num = allData?.summary?.note)
        // list[1] && (list[1].num = allData?.summary?.photo)
        // list[18] && (list[18].num = allData?.summary?.reminder)
        // list[4] && (list[4].num = allData?.summary?.video)
        // list2[3].num = allData.summary.location
        // list2[4].num = allData.summary.photo
        // list2[5].num = allData.summary.video

        // 根据设备id获取高级数据
        let deviceUdid =
          JSON.parse(localStorage.getItem('currentDevice')) != null
            ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
            : ''
        if (summary.advance != null) {
          try {
            let find = summary.advance.find(row => {
              if (row.device != null && row.device.unique_identifier == deviceUdid) {
                return row
              }
            })
            if (find) {
              list[9].num = find.sms
              list[10].num = find.call
              list[11].num = find.voicemail
              list[12].num = find.whatsapp
              list[13].num = find.whatsapp_smb
              list[14].num = find.line
              list[15].num = find.kik
              list[16].num = find.wechat
              list[17].num = find.facebook_messenger
              list[18].num = find.safari_history
              list[19].num = find.safari_bookmark
              list[20].num = find.app
              list[21].num = find.wifi
              list[22].num = find.skype_interaction
              list[23].num = find.teams_interaction
              list[24].num = find.telegram_interaction
              list[25].num = find.snapchat_interaction
              list[26].num = find.instagram_interaction
              list[27].num = find.facetime_interaction

              // 旧icon顺序高级数据赋值
              // list[6].num = find.call
              // list[12].num = find.app
              // list[5].num = find.line
              // list[8].num = find.facebook_messenger
              // list[11].num = find.kik
              // list[10].num = find.safari_bookmark
              // list[7].num = find.safari_history
              // list[0].num = find.sms
              // list[14].num = find.wechat
              // list[2].num = find.whatsapp
              // list[13].num = find.wifi
              // list[17].num = find.whatsapp_smb
              // list[20].num = find.skype_interaction
              // list[21].num = find.teams_interaction
              // list[22].num = find.telegram_interaction
              // list[23].num = find.snapchat_interaction
              // list[24].num = find.instagram_interaction
              // list[25].num = find.facetime_interaction

              // list2[0].num = find.sms
              // list2[1].num = find.whatsapp
              // list2[2].num = find.facebook_messenger
              // list2[6].num = find.call
              // list2[7].num = find.safari_history
              // list2[8].num = find.snapchat_interaction
            }

            let _isHasData = false

            Object.keys(find).forEach(key => {
              if (key != 'device') {
                if (find[key]) {
                  _isHasData = true
                }
              }
            })
            setIsInviteComment(_isHasData)
          } catch (error) { }
        }

        localStorage.setItem('userSummary', JSON.stringify(list))

        setList([...list])

        // setIconList(list2)

        // 处理message数据
        let message = await getAllDashboard({
          username: deviceUsername,
          params: {
            category: 'SMS_CHAT_SUMMARY',
            offset: 0,
            limit: 4,
            deviceUdid: deviceUdid
          }
        })

        // 处理message数据
        setMessages(message.data.contents != null ? message.data.contents : [])

        // 处理安装app

        let app = await getAllDashboard({
          username: deviceUsername,
          params: {
            category: 'INSTALLED_APP',
            offset: 0,
            limit: 4,
            deviceUdid: deviceUdid
          }
        })

        setInstalledApp(app.data.contents != null ? app.data.contents.slice(0, 4) : [])

        // 处理位置

        let reqLocation = await getAllDashboard({
          username: deviceUsername,
          params: {
            category: 'LOCATION',
            offset: 0,
            limit: 4,
            deviceUdid: deviceUdid
          }
        })

        if (reqLocation.data.contents == null) {
          setLocations([])
        } else {
          let storageLocations = JSON.parse(localStorage.getItem('gpsLocations')) || []

          let locationResult = reqLocation.data.contents

          for (let i = 0; i < locationResult.length; i++) {
            locationResult[i].id = i + 1
            locationResult[i].lat = locationResult[i].latitude
            locationResult[i].lng = locationResult[i].longitude
            locationResult[i].time = dayjs(locationResult[i].timeStamp).format('D MMM,hh:mm a')

            locationResult[i].position = await location(
              `${locationResult[i].latitude}`,
              `${locationResult[i].longitude}`
            )
          }

          setDefaultProps(locationResult[0])

          setSelectLocations(locationResult[0])

          setLocations(locationResult)
        }
      }

      setCallData()

      // 延迟获取高级数据
      timer = setTimeout(() => {
        setCallData()
        getTargetDeviceList()
      }, 3000)
    } catch (error) {
      console.log(error)
    }

    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [])

  // 数据量最多的常用app列表
  const [frequentlyArr, setFrequentlyArr] = useState([])
  const [basicArr, setBasicArr] = useState([]) // 基础服务app列表
  const [extremeArr, setExtremeArr] = useState([]) // 高级服务app列表
  const [innerWidth, setInnerWidth] = useState(0) // 实时屏幕宽度

  // 监听屏幕宽度变化
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handlerResize = () => {
        setInnerWidth(window.innerWidth)
      }
      handlerResize()

      window.addEventListener('resize', handlerResize)

      return () => {
        window.removeEventListener('resize', handlerResize)
      }
    }
  }, [])

  //初始化列表
  useEffect(() => {
    if (useList && useList.length > 0) {
      // 增值服务上线前付费用户展示数据，移动端的常用app为数量倒序，其他的hot app未排序
      if (innerWidth < 780) {
        // 过滤出指定 name 的 icon 并按 num 值降序排序
        let selectedIcons = useList.filter(icon => {
          return (
            [
              'Text message',
              'WhatsApp',
              'Messenger',
              'Locations',
              'Photo',
              'Video',
              'Call',
              'Browser Bookmark',
              'Snapchat'
            ].includes(icon.name) && icon.num > 0
          )
        })

        // if (selectedIcons.length === 0) {
        //   return
        // }

        // 过滤出不在 selectedIcons 中的其他 icon 并按 num 值降序排序
        let _selectedIcons = useList
          .filter(
            icon =>
              !(
                [
                  'Text message',
                  'WhatsApp',
                  'Messenger',
                  'Locations',
                  'Photo',
                  'Video',
                  'Call',
                  'Browser Bookmark',
                  'Snapchat'
                ].includes(icon.name) && icon.num > 0
              )
          )
          .sort((a, b) => b.num - a.num)

        setCloneList([...selectedIcons, ..._selectedIcons].slice(0, 9))
        setFrequentlyArr([...selectedIcons, ..._selectedIcons].sort((a, b) => b.num - a.num).slice(0, 3))
      } else {
        setCloneList(useList)
        setFrequentlyArr([...useList].sort((a, b) => b.num - a.num).slice(0, 3))
      }

      // 基础服务map映射
      const basicMap = new Map([
        'Photo',
        'Video',
        'Locations',
        'Contact',
        'Mail',
        'iCloud drive',
        'Note',
        'Calendar',
        'Reminder'
      ].map(item => ([item, null])))

      // 增值服务map映射
      const extremeMap = new Map([
        'Text message',
        'Call',
        'Voicemail',
        'WhatsApp',
        'WA Business',
        'Line',
        'Kik',
        'WeChat',
        'Messenger',
        'Browser history',
        'Browser Bookmark',
        'Install Apps',
        'Wi-Fi network',
        'Skype',
        'Teams',
        'Telegram',
        'Snapchat',
        'Instagram',
        'Facetime'
      ].map(item => ([item, null])))

      // 遍历处理后的功能数据统计，填充到对应的分区
      useList.forEach(item => {
        if (basicMap.has(item.name)) {
          basicMap.set(item.name, item)
        }
        if (extremeMap.has(item.name)) {
          extremeMap.set(item.name, item)
        }
      })

      const basicArr = Array.from(basicMap.values())
      setBasicArr(basicArr)

      const extremeArr = Array.from(extremeMap.values())
      setExtremeArr(extremeArr)
    }
  }, [useList, innerWidth])

  let currentDevice = JSON.parse(window.localStorage.getItem('currentDevice'))
  if (currentDevice == null) {
    currentDevice = {
      'Build Version': '',
      'Device Name': '',
      'Product Type': '',
      'Serial Number': ''
    }
  }

  const [defaultProps, setDefaultProps] = useState({
    center: {
      lat: 40.73061,
      lng: -73.935242
    },
    zoom: 14
  })

  const [tips, setTips] = useState(false)

  const switchDev = async () => {
    let check = await userDeviceCurrent()
    if (check.all.includes('android')) {
      localStorage.removeItem('DeviceUser')
      localStorage.setItem('currentMode', 'android')
      router.push('/android' + window.location.pathname)
    } else {
      setTips(true)
    }
  }

  // 显示布局选项
  const [layoutCurdOpen, setLayoutCurdOpen] = useState(false)

  // 全部类型
  const [layoutOptions, setLayoutOptions] = useState([])

  // 打开布局
  const handleLayout = () => {
    setLayoutCurdOpen(true)

    // 过滤
    let all = navigation().filter(row => {
      let filter = ['Dashboard', 'My account', 'GPS location']
      if (typeof row.title != 'undefined' && !filter.includes(row.title)) {
        return row
      }
    })

    all = all.map(row => {
      return {
        ...row,
        label: row.title,
        value: row.path,
        icon: ''
      }
    })
    setLayoutOptions(all)
  }

  // 保存选项
  const [saveLayout, setSaveLayout] = useState([])

  // 处理选项

  const layoutChange = e => {
    let save = JSON.parse(JSON.stringify(saveLayout))
    if (save.length == 3) {
      save = save.slice(1, 3)
    }

    setSaveLayout([...save, { title: e.title, path: e.path, category: e.category }])
  }

  // 发送保存选项
  const sendSaveLayout = async () => {
    setLayoutCurdOpen(false)

    await sendLikeType({
      likeType: saveLayout,
      username:
        JSON.parse(localStorage.getItem('DeviceUser')) != null
          ? JSON.parse(localStorage.getItem('DeviceUser')).username
          : ''
    })
  }

  useEffect(() => {
    let likeType = localStorage.getItem('DeviceUser')
  }, [])

  useEffect(() => {
    dispatch(setCurrentTab(t('Dashboard')))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, locale])

  useEffect(() => {
    getUserAccountOrder({ page: 1, pageSize: 10 })
  }, [])

  const conversionUtcDate = (date, type, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (type === 'local') {
      // 传入local则将UTC时间转换为本地时间
      return dayjs.utc(date).local().format(format)
    } else if (type === 'UTC') {
      // 传入UTC则将时间转换为UTC时间
      return dayjs(date).utc().format()
    }
  }

  function handlerDateDurationCurrent(time) {
    if (new Date(time) < new Date()) {
      return 0
    }
    let d1 = new Date(time)
    let d2 = new Date()

    let cha = Math.abs(d2.getTime() - d1.getTime())
    let days = parseInt(cha / (24 * 60 * 60 * 1000))
    let hours = parseInt((cha % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000))
    let mins = parseInt((cha % (60 * 60 * 1000)) / (60 * 1000))
    if (days) {
      return ` ${days}d`
    } else if (hours) {
      return `+ ${hours}h ${mins}m`
    } else {
      return `+ ${mins}m`
    }
  }

  const [orderListData, setOrderListData] = useState({})

  // 当前设备的平台类型，取【设备接口】user-device，不用订单的 platform_type（后者不准）
  const [currentDevicePlatform, setCurrentDevicePlatform] = useState('')
  const [orderList, setOrderList] = useState([])

  const [notBindICloud, setNotBindICloud] = useState(false) // 增值服务上线前付费且从未绑定过iCloud

  const setOrderData = async () => {
    const res = await getUserAccountOrder({ page: 1, pageSize: 9999 })
    const orders = Array.isArray(res?.data) ? res.data : []

    let deviceUser = {}
    try {
      deviceUser = JSON.parse(localStorage.getItem('DeviceUser') || '{}') || {}
    } catch (e) {
      deviceUser = {}
    }
    const username = deviceUser.username || ''

    orders.forEach((item, index) => {
      const accountNumber = (index + 1).toString().padStart(2, '0')
      item.name = `Account${accountNumber}`
    })

    setOrderList(orders)

    // 设备接口（user-device）记录：带 order_id（后端指明这台设备当前是哪张单）与 platform_type。
    // 侧栏 / 刷新到期时间时都会把它写进 allDeviceUser，这里直接读缓存，不额外打接口。
    let currentDevice = null
    try {
      const cachedDevices = JSON.parse(localStorage.getItem('allDeviceUser') || '[]')
      currentDevice = matchCurrentDevice(Array.isArray(cachedDevices) ? cachedDevices : [], deviceUser)
    } catch (e) {
      currentDevice = null
    }
    setCurrentDevicePlatform(currentDevice?.platform_type || '')

    // 只取【当前设备】的关联订单：
    // 优先用设备上的 order_id 直接命中订单主键；没有 order_id 才按 device_id / iCloud 账号找，
    // 且同一设备有多张单时取过期时间最晚的那张（最新的关联单）。
    // 不能用「全局过期最晚的一张」——那会把别的设备（例如安卓单）的到期时间和
    // Basic/Extreme 档位显示到当前设备上。
    const currentOrder = resolveDeviceOrder({ orders, deviceUser, device: currentDevice })

    // 展示字段以【设备接口】为准：user-device 现在直接返回
    // order_id / product_name / order_level / expire_time，就是这台设备当前的订阅状态；
    // 订单只用于补设备接口没有的字段（如 merchant_no）。
    const cardOrder = resolveCardSubscription({ order: currentOrder, device: currentDevice })

    const result = cardOrder.expire_time
      ? {
          ...cardOrder,
          key: cardOrder.id ?? currentDevice?.order_id,
          createdAt: conversionUtcDate(cardOrder.createdAt, 'local'),
          expire_time: conversionUtcDate(cardOrder.expire_time, 'local', 'YYYY-MM-DD'),
          remainingDays: handlerDateDurationCurrent(cardOrder.expire_time)
        }
      : {}

    setOrderListData(result)

    setNotBindICloud(!username) // 设置用户是否绑定过设备


    // 增值服务之前付费用户状态更改
  }

  useEffect(() => {
    setOrderData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceRequestKey])

  // 延长续订
  const [extendSubscriptionModal, setExtendSubscriptionModal] = useState(false)

  const extendSubscription = async () => {
    try {
      const renewId = await fetchRenewProductIdForOrder(orderListData)
      if (!renewId) {
        window.dispatchEvent(new Event('renewalFailed'))
        messageInfo({
          content: t('Payment failed'),
          duration: 6
        })

        return
      }

      const result = await extendSubscriptionTime({
        merchant_no: orderListData.merchant_no,
        renewId,
        order_type: 274
      })

      // HTTP 200 但业务 code 非 0 也属于续费失败；通知全局续费组件展示新支付方式兜底弹窗。
      if (Number(result?.code) !== 0) {
        messageInfo({
          content: `${result.msg}`,
          duration: 6
        })
        window.dispatchEvent(new Event('renewalFailed'))

        return
      }

      // 续费成功：先给用户可感知的反馈，再整页刷新。
      // 不做局部刷新是因为覆盖不全：ExpirationReminder 的 banner 依赖 Redux 的 deviceUser，
      // 而 refreshSubscriptionExpire 只 bump deviceSwitchRevision、不动 deviceUser，
      // 过期 banner / 遮罩可能仍停在「已过期」视图。
      // 整页刷新最稳，也与 ExpiredPurchaseGuide 的成功处理保持一致。
      messageInfo({
        content: `${result.msg}`,
        duration: 1.5
      })
      reloadAfterRenewSuccess()
    } catch (error) {
      console.error('续订失败：', error)
      messageInfo({
        content: error?.response?.data?.msg || error?.msg || t('Payment failed'),
        duration: 6
      })
      window.dispatchEvent(new Event('renewalFailed'))
    } finally {
      setExtendSubscriptionModal(false)
    }
  }

  const openNav = () => {
    dispatch(toggleNavVisibility(true))
  }

  // 处理订阅月份显示文字
  const handlerPlanText = name => {
    if (!name) return ''
    const match = name.match(/\d+/g) // 提取月份数字部分
    const months = match ? Number(match[0]) : 1 // 默认值为1，防止 undefined

    return months >= 3 ? name : name.replace('Months', 'Month')
  }

  // ===== 首页 Extreme 升级弹窗 =====
  // 判断口径与功能页一致，但这里只取结果、不触发「未绑高级跳验证页」的跳转，
  // 避免把用户从首页带到验证页。
  const extremeGateApplies = shouldApplyIosExtremeBindGate(store.currentMode)
  const extremeResetPending = extremeGateApplies && isResetTimePending(store.resetTime)
  const extremeBindIncomplete = extremeGateApplies && isAdvancedVerificationIncomplete(store.resetTime)
  const hasExtremePlan = store.extremeService === true || store.extremeService === 'true'

  // 续费优先：已过期（宽限期）或 7 天内到期时，不弹升级
  const currentDeviceRow = (() => {
    try {
      return JSON.parse(localStorage.getItem('DeviceUser') || 'null')
    } catch {
      return null
    }
  })()
  const currentDeviceStatus = resolveDeviceSubscriptionStatus(currentDeviceRow || {})
  const currentDeviceExpireMs = parseExpireMs(
    resolveDeviceExpireTime(currentDeviceRow) ?? currentDeviceRow?.expire_time
  )
  const renewalTakesPriority =
    currentDeviceStatus === SUBSCRIPTION_STATUS.GRACE ||
    currentDeviceStatus === SUBSCRIPTION_STATUS.LAPSED ||
    (Number.isFinite(currentDeviceExpireMs) && currentDeviceExpireMs - Date.now() <= 7 * 24 * 60 * 60 * 1000)

  // 关闭后当天不再弹（按设备记录）
  const upgradeDismissKey = `extremeUpgradeDismissed-${store.deviceUser || ''}`
  const readUpgradeDismissed = key => {
    try {
      return localStorage.getItem(key) === dayjs().format('YYYY-MM-DD')
    } catch {
      return false
    }
  }

  // 首屏/切设备时同步读取当天记录，避免「先闪一下弹窗再消失」
  const [upgradeDismiss, setUpgradeDismiss] = useState(() => ({
    key: upgradeDismissKey,
    dismissed: readUpgradeDismissed(upgradeDismissKey)
  }))
  if (upgradeDismiss.key !== upgradeDismissKey) {
    setUpgradeDismiss({ key: upgradeDismissKey, dismissed: readUpgradeDismissed(upgradeDismissKey) })
  }

  // 首页需要高级绑定状态才能判断是否该弹升级窗；功能页各自拉取，这里补一次（仅 iOS-Cloud）
  useEffect(() => {
    if (!extremeGateApplies || !store.deviceUser) return
    dispatch(fetchResetTime())
  }, [dispatch, extremeGateApplies, store.deviceUser, store.deviceSwitchRevision])

  const closeUpgradeModal = () => {
    setUpgradeDismiss({ key: upgradeDismissKey, dismissed: true })
    try {
      localStorage.setItem(upgradeDismissKey, dayjs().format('YYYY-MM-DD'))
    } catch {
      // localStorage 不可用时仅本次会话内关闭，不影响页面
    }
  }

  const showDashboardUpgrade =
    extremeGateApplies &&
    !extremeResetPending &&
    !extremeBindIncomplete &&
    !hasExtremePlan &&
    !renewalTakesPriority &&
    !upgradeDismiss.dismissed

  // 卡片上的 Product 一律以【设备接口】的平台类型为准，
  // 订单接口的 platform_type 表示「买的产品」，不等于当前设备类型。
  const cardPlatformType = currentDevicePlatform || orderListData?.platform_type || ''

  const currentDeviceUdid =
    JSON.parse(localStorage.getItem('currentDevice') || 'null')?.['Unique Identifier'] || ''

  const currentTargetDevice =
    targetDeviceList.find(item => item.unique_identifier === currentDeviceUdid) ||
    targetDeviceList[0] ||
    null

  return (
    <div style={{ userSelect: 'none' }}>
      <FirstBinding />
      {/* 复用本页已拉取的订单列表（同一接口同一参数），避免组件内再打一次 user-account-order；
          与 /android/dashboard、/android/local/dashboard 的用法保持一致 */}
      <ExpirationReminder orders={orderList} />
      <ExtremeUpgradeModal open={showDashboardUpgrade} onClose={closeUpgradeModal} />
      <Grid container spacing={6} sx={{}}>
        <Grid item xs={12} md={12} lg={12}>
          {/* <>
            <Card style={{ width: '100%', marginBottom: '20px' }} sx={{
              '@media (min-width: 1200px)': {
                display: 'none'
              }
            }}>
              <div className='w-full flex justify-between items-center mb-[10px] px-[18px] pt-4'>
                <h2 className='text-[18px] text-[#222] font-[600] Bxls:hidden'>{t('Frequently used')}</h2>
              </div>
              <CardContent style={{ display: 'flex', flexWrap: 'wrap', paddingBottom: '0px' }}>
                {frequentlyArr.map(row => (
                  <Grid
                    key={row.id}
                    item
                    xs={4}
                    md={3}
                    lg={2}
                    className='sm:hidden'
                    style={{
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBottom: '10px'
                    }}
                  >
                    <Link className='flex flex-col items-center justify-center' href={row.href}>
                      <div className='w-[50px] h-[50px] relative'>
                        <Image
                          src={row.img}
                          alt='img'
                          width={50}
                          height={50}
                          className='mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative'
                        />
                        <span className='absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center'>
                          {row.num}
                        </span>
                      </div>

                      <span
                        className='text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center'
                        style={{ textAlign: 'center' }}
                      >
                        {t(row.name)}
                      </span>
                    </Link>
                  </Grid>
                ))}
              </CardContent>
            </Card>

            <Card style={{ width: '100%' }}>
              <div className='w-full flex justify-between items-center mb-[10px] px-[18px] pt-4'>
                <h2 className='text-[18px] text-[#222] font-[600] Bxls:hidden'>{t('Hot features')}</h2>
                <h2 className='text-[18px] text-[#222] font-[600] hidden Bxls:block'>{t('Features')}</h2>
                <div
                  className=' border-0 px-[10px] h-[30px] rounded-[22.5px] hover:bg-[#454CFF] text-[#454CFF] hover:text-[#FFF] text-[12px] Bxls:hidden flex items-center font-[600]'
                  onClick={openNav}
                >
                  {t('SEE ALL')}
                </div>
              </div>
              <CardContent style={{ display: 'flex', flexWrap: 'wrap' }}>
                {CloneList.map(row => (
                  <Grid
                    key={row.id}
                    item
                    xs={4}
                    md={3}
                    lg={2}
                    className='sm:hidden'
                    style={{
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBottom: '10px'
                    }}
                  >
                    <Link className='flex flex-col items-center justify-center' href={row.href}>
                      <div className='w-[50px] h-[50px] relative'>
                        <Image
                          src={row.img}
                          alt='img'
                          width={50}
                          height={50}
                          className='mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative'
                        />
                        <span className='absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center'>
                          {row.num}
                        </span>
                      </div>

                      <span
                        className='text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center'
                        style={{ textAlign: 'center' }}
                      >
                        {t(row.name)}
                      </span>
                    </Link>
                  </Grid>
                ))}
              </CardContent>
            </Card>
          </> */}

          {/* 基础服务列表 */}
          <Card style={{ width: '100%', marginBottom: '20px' }}>
            <div className='w-full flex justify-between items-center mb-[26px] Mlg:mb-0 pt-[24px] Mlg:pt-[16px] pl-[40px] Mlg:pl-[16px]'>
              <h2 className='text-[18px] text-[#222] font-[600] leading-[27px]'>{t('Basic Features')}</h2>
            </div>
            <CardContent style={{ display: 'flex', flexWrap: 'wrap' }} sx={{
              '@media (min-width: 768px)': {
                padding: '0px !important'
              },
              '@media (max-width: 768px)': {
                padding: '22px !important'
              }
            }}>
              {basicArr.map(row => (
                <Grid
                  key={row.id}
                  item
                  xs={4}
                  md={3}
                  lg={2}
                  className='sm:hidden'
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                  sx={{
                    '@media (min-width: 768px)': {
                      marginBottom: '50px !important'
                    },
                    '@media (max-width: 768px)': {
                      marginBottom: '30px !important'
                    }
                  }}
                >
                  <Link className='flex flex-col items-center justify-center' href={row.href}>
                    <div className='w-[50px] h-[50px] relative'>
                      <Image
                        src={row.img}
                        alt='img'
                        width={50}
                        height={50}
                        className='mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative'
                      />
                      <span className='absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center'>
                        {row.num}
                      </span>
                    </div>

                    <span
                      className='mt-[10px] text-[16px] Mlg:text-[12px] text-[#2E2E2E] leading-[24px] Mlg:leading-[21px] w-full text-center'
                      style={{ textAlign: 'center' }}
                    >
                      {t(row.name)}
                    </span>
                  </Link>
                </Grid>
              ))}
            </CardContent>
          </Card>

          {/* 增值服务列表 */}
          <Card style={{ width: '100%', marginBottom: '20px' }}>
            <div className='w-full flex justify-between items-center mb-[26px] Mlg:mb-0 pt-[24px] Mlg:pt-[16px] pl-[40px] Mlg:pl-[16px]'>
              <h2 className='text-[18px] text-[#222] font-[600] leading-[27px]'>Extreme&nbsp;{t('Features')}</h2>
            </div>
            <CardContent style={{ display: 'flex', flexWrap: 'wrap' }} sx={{
              '@media (min-width: 768px)': {
                padding: '0px !important'
              },
              '@media (max-width: 768px)': {
                padding: '22px !important'
              }
            }}>
              {extremeArr.map(row => (
                <Grid
                  key={row.id}
                  item
                  xs={4}
                  md={3}
                  lg={2}
                  className='sm:hidden'
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                  sx={{
                    '@media (min-width: 768px)': {
                      marginBottom: '50px !important'
                    },
                    '@media (max-width: 768px)': {
                      marginBottom: '30px !important'
                    }
                  }}
                >
                  <Link className='flex flex-col items-center justify-center' href={row.href}>
                    <div className='w-[50px] h-[50px] relative'>
                      <Image
                        src={row.img}
                        alt='img'
                        width={50}
                        height={50}
                        className='mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative'
                      />
                      <span className='absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center'>
                        {row.num}
                      </span>
                    </div>

                    <span
                      className='mt-[10px] text-[16px] Mlg:text-[12px] text-[#2E2E2E] leading-[24px] Mlg:leading-[21px] w-full text-center'
                      style={{ textAlign: 'center' }}
                    >
                      {t(row.name)}
                    </span>
                  </Link>
                </Grid>
              ))}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <div className='grid grid-cols-3 Hsm:grid-cols-2 Hsm:Dsm:grid-cols-1 w-full Dmd:gap-[20px] Hsm:Dsm:gap-y-[20px] mt-[20px]'>
        <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[30px]'>
          <div className='flex justify-between items-center relative'>
            <h2 className='text-[18px] text-[#222] font-[600]'>{t('Account')}</h2>
            <div
              className='hover:cursor-pointer'
              ref={toggleButtonRef} // 绑定按钮引用
              onClick={event => {
                event.stopPropagation() // 阻止事件冒泡
                setShowOrderList(prev => !prev) // 确保状态切换
              }}
            >
              <Image
                className='w-[24px] h-[24px]'
                src='/images/change-password/drop-down.svg'
                width={24}
                height={24}
                alt='drop down'
              ></Image>
            </div>
            {showOrderList && (
              <div
                ref={orderListRef}
                className='bg-[#FFF] w-full absolute left-0 top-[40px] z-10 rounded-[8px] p-[8px] drop-shadow-[0_4px_8px_rgba(0,0,0,0.13)] overflow-auto'
              >
                {orderList.map((row, index) => (
                  <div
                    key={index}
                    onClick={() => changeOrder(row, index)}
                    className={`hover:bg-[#F4F5F6] hover:cursor-pointer px-[15px] py-[10px] ${orderIndex === index ? 'bg-[#F4F5F6]' : ''
                      }`}
                  >
                    {row.name}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className='w-full h-[1px] bg-[#E5E5E5] mt-[20px] mb-[24px]'></div>
          <div className='w-full h-[108px] flex flex-col justify-between text-[14px]'>
            <div className='w-full flex justify-between items-center'>
              <div className='text-[#334062]'>{t('Product')}:</div>
              <div className='text-[#9198AD]'>{cardPlatformType}</div>
            </div>
            <div className='w-full flex justify-between items-center'>
              <div className='text-[#334062]'>{t('Subscription Plan')}:</div>
              <div className='text-[#9198AD]'>{isBasicOrderLevel(orderListData?.order_level) ? `${t('Basic')} - ` : 'Extreme - '}{handlerPlanText(orderListData.product_name)}</div>
            </div>
            <div className='w-full flex justify-between items-center'>
              <div className='text-[#334062]'>{t('Expiry Date')}:</div>
              <div className='text-[#9198AD]'>{dayjs(orderListData.expire_time).format('YYYY-MM-DD')}</div>
            </div>
          </div>
          <button
            className='text-[#454CFF] w-full h-[45px] border border-[#454CFF] rounded-[22.5px] mt-[36px] hover:bg-[#454CFF] hover:text-[#FFF]'
            onClick={() => setExtendSubscriptionModal(true)}
          >
            {t('Extend subscription')}
          </button>
        </div>

        <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[24px]'>
          <h2 className='text-[18px] text-[#222] font-[600] mb-[20px]'>{t('Target Device Info')}</h2>
          <div className='w-full min-h-[54px] bg-[#F4F5F6] rounded-[8px] pl-[8px] pr-[14px] flex items-center text-[#334062] text-[16px]'>
            <Image
              className='mb-[2px]'
              src='/images/dashboard/apple_logo.svg'
              width={24}
              height={24}
              alt='apple logo'
            ></Image>
            <div className='ml-[10px] w-full break-all'>{currentTargetDevice?.device_name}</div>
          </div>
          <div className='w-full h-[152px] mt-[24px] flex flex-col justify-between'>
            <div className='w-full flex justify-between items-center text-[14px]'>
              <div className='text-[#334062]'>IMEI:</div>
              <div className='text-[#9198AD]'>{currentTargetDevice?.serial_number}</div>
            </div>
            <div className='w-full flex justify-between items-center text-[14px]'>
              <div className='text-[#334062]'>{t('iOS version')}:</div>
              <div className='text-[#9198AD]'>{currentTargetDevice?.product_version}</div>
            </div>
            <div className='w-full flex justify-between items-center text-[14px]'>
              <div className='text-[#334062]'>{t('Last backup time')}:</div>
              <div className='text-[#9198AD]'>{currentTargetDevice?.updated_at}</div>
            </div>
            <div className='w-full flex justify-between items-center text-[14px]'>
              <div className='text-[#334062]'>{t('Last backup size')}:</div>
              <div className='text-[#9198AD]'>{currentTargetDevice?.size}</div>
            </div>
          </div>
        </div>
        {/* <div className='drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] Hsm:hidden'> */}
        {/* <Carousel className='w-full mt-[20px] h-auto'>
            <div> */}
        {/* <Image src='/images/dashboard/mask-group.png' fill alt='photo1' className='w-full'></Image> */}
        {/* </div>
            <div></div>
          </Carousel> */}
        {/* <div className='absolute bottom-[17px] w-full flex justify-center'>
          <div className='w-[36px] h-[4px] bg-[#FFF] rounded-[2px]'></div>
          <div className='w-[36px] h-[4px] bg-[rgba(255,255,255,0.2)] rounded-[2px] ml-[12px]'></div>
        </div> */}
        {/* </div> */}


        {/* 推荐广告轮播暂时下架 */}
        {/* <Carousel autoplay autoplaySpeed={3000} className='w-full h-full'>
          <div>
            <Image
              src='/images/dashboard/referfriends1.png'
              width={0}
              height={0}
              alt='ReferFriends1'
              className='w-full h-full cursor-pointer'
              onClick={() => router.push('/referral-program')}
            ></Image>
          </div>
          <div>
            <Image
              src='/images/dashboard/referfriends2.png'
              width={0}
              height={0}
              alt='ReferFriends2'
              className='w-full h-full cursor-pointer'
              onClick={() => router.push('/referral-program')}
            ></Image>
          </div>
          <div>
            <Image
              src='/images/dashboard/referfriends3.png'
              width={0}
              height={0}
              alt='ReferFriends3'
              className='w-full h-full cursor-pointer'
              onClick={() => router.push('/referral-program')}
            ></Image>
          </div>
          {isInviteComment && (
            <div>
              <Image
                src='/images/dashboard/invitecomment.png'
                width={0}
                height={0}
                alt='inviteComment'
                className='w-full h-full cursor-pointer'
                onClick={() => router.push('https://www.trustpilot.com/review/msafely.com')}
              ></Image>
            </div>
          )}
        </Carousel> */}
      </div>

      {/* 验证流程 */}
      {/* <IosVerfiyProcess /> */}

      <Modal open={tips} onCancel={() => setTips(false)} footer={[]} zIndex={1200}>
        <p>
          {t(
            'Currently you have only purchased the iPhone monitoring package If you want to monitor an Android device please click the button'
          )}
        </p>
        <div style={{ textAlign: 'center', marginTop: '20px', padding: '8px 22px', borderRadius: '10px' }}>
          <Link
            target='_blank'
            href={process.env.NEXT_PUBLIC_CLIENT_URL + '/choose-monitored-device'}
            style={{ background: '#07273D', color: '#fff', padding: '7px 14px', borderRadius: '10px' }}
          >
            {t('Add an Android device')}
          </Link>
        </div>
      </Modal>
      {/* 选择布局 */}
      <Modal open={layoutCurdOpen} footer={[]} zIndex={1200} closable={false} width={700} className='equipment'>
        <div
          style={{
            background: '#E7E7E7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 10px',
            borderTopRightRadius: '8px',
            borderTopLeftRadius: '8px'
          }}
        >
          <h2 style={{ color: '#000000', fontSize: '22px' }}>{t('choose 3 you like type')}</h2>
          <Icon
            icon='ic:round-cancel'
            color='#494949'
            style={{ fontSize: '18px', cursor: 'pointer' }}
            onClick={() => setLayoutCurdOpen(false)}
          />
        </div>

        <div>
          {layoutOptions.map((row, i) => {
            return (
              <Checkbox
                style={{ margin: '4px', width: '150px' }}
                checked={saveLayout.find(item => item.path == row.path)}
                key={i}
                onChange={() => layoutChange(row)}
              >
                {row.label}
              </Checkbox>
            )
          })}
        </div>

        <div
          style={{
            margin: '0 auto',
            marginTop: '16px',
            width: '60px',
            height: '30px',
            lineHeight: '30px',
            textAlign: 'center',
            background: '#2A99FF',
            color: '#fff',
            borderRadius: '10px'
          }}
          onClick={() => {
            sendSaveLayout()
          }}
        >
          OK
        </div>
      </Modal>

      {/* 延长续费 */}

      <Modal open={extendSubscriptionModal} onCancel={() => setExtendSubscriptionModal(false)} footer={[]}>
        <p style={{ marginTop: '10px', fontWeight: '600' }}>
          {t('After confirmation a new order will be produced to extend the equipment expiration time')}
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '14px' }}>
          <Button onClick={() => extendSubscription()} style={{ marginRight: '10px' }}>
            {t('Confirm')}
          </Button>
          <Button onClick={() => setExtendSubscriptionModal(false)}>{t('Cancel')}</Button>
        </div>
      </Modal>
    </div>
  )
}

export default Dashboard1
